export default "__VITE_ASSET__6ff4e264__"